import React, { useEffect, useState, useCallback } from 'react'
import { CurrentTimeIndicator } from '../../component/Appointments/CurrentTimeIndicator'
import dayjs from 'dayjs'
import HourCanva from '../../component/Appointments/HourCanva'
import DragDropAppointmentList from '../../component/Appointments/DragDropAppointmentList'
import "./Appointments.css"
import DateSelect from '../../component/Appointments/DateSelect'
import { useLocation, useNavigate } from 'react-router-dom'
import queryString from "query-string";
import { useDispatch, useSelector } from 'react-redux'
import { getAppointments } from '../../redux/actions/appointment/appointment'
import Loading from '../../component/Common/Loading/Loading'
import { MessageError } from '../../component/Common/MessageError/MessageError'
import { NoticeBar, PullToRefresh } from 'antd-mobile'
import AddNew from '../../component/Appointments/AddNew'
import RefreshAppointments from '../../component/Appointments/RefreshAppointments'
const blockTimeHeight = 30

const Appointments = () => {
	const dispatch = useDispatch()
	const location = useLocation()

	const [isWaitingBlockTime, setIsWaitingBlockTime] = useState(false);
	const [isWaitingAppointment, setIsWaitingAppointment] = useState(false);
	let queryObject = queryString.parse(location.search);
	const { allowCreateBlockTime, allowCreateAppointment } = useSelector(state => state.authenticate.user)
	const [state, setState] = useState({
		popUpVisible: false,
		date: queryObject.date ? dayjs(queryObject.date).format("YYYY-MM-DD") : dayjs().format("YYYY-MM-DD"),
	});
	const timeZone = useSelector(
		(state) => state.generalInfo?.staff?.business?.timeZone || ""
	);

	const navigate = useNavigate()

	const { loading, message, error } = useSelector(state => state.appointment)

	const {
		date,
	} = state;

	const isToday = dayjs().isSame(
		dayjs(date).format("YYYY-MM-DD"),
		"day"
	);

	const refreshAppointments = useCallback(() => {
		if (date) {
			dispatch(getAppointments(date, timeZone));
		}
	}, [date, timeZone, dispatch]);

	const handleChangeDate = (value) => {
		const newQuery = { ...queryString.parse(location.search), date: value };
		navigate({ pathname: "/", search: `?${queryString.stringify(newQuery)}` });
	};

	useEffect(() => {
		refreshAppointments();
	}, [refreshAppointments]);

	useEffect(() => {
		const queryObject = queryString.parse(location.search);
		const urlDate = queryObject.date
			? dayjs(queryObject.date).format("YYYY-MM-DD")
			: dayjs().format("YYYY-MM-DD");

		setState(prev => ({
			...prev,
			date: urlDate,
			dayOfWeek: dayjs(urlDate, "YYYY-MM-DD").day(),
		}));
	}, [location.search]);


	useEffect(() => {
		MessageError(message, error)
	}, [error, message])

	if (loading) return <Loading />
	return (
		<div style={{ width: "100%", minHeight: "100%" }}>
			<PullToRefresh onRefresh={refreshAppointments} >
				<div
					style={{ paddingBottom: "20px", paddingTop: "20px", position: "sticky", top: 46, left: 0, zIndex: 50, background: "white", width: "100%" }}
				>

					<DateSelect
						handleChangeDate={handleChangeDate}
						date={date}
					/>

				</div>

				<div
					style={{
						position: "relative",
						width: "100%",
						paddingBottom: "30px",
					}}
				>
					<CurrentTimeIndicator isToday={isToday} />
					<div
						style={{
							width: "100%",
							position: "absolute",
						}}
					>
						<HourCanva
							blockTimeHeight={blockTimeHeight}
							date={date}
							isWaitingBlockTime={isWaitingBlockTime}
							isWaitingAppointment={isWaitingAppointment}
						/>
					</div>
					<div style={{ position: "relative" }}>
						<DragDropAppointmentList
							blockTimeHeight={blockTimeHeight}
							navigate={navigate}
							allowCreateBlockTime={allowCreateBlockTime}
							allowCreateAppointment={allowCreateAppointment}
						/>
					</div>
				</div>

				{isWaitingBlockTime && <NoticeBar
					className={'block-time-notice'}
					style={{
						position: "fixed",
						bottom: 0, left: 0, width: "100%",
						zIndex: 100,
						height: 60,
						fontSize: 16,
						fontWeight: "bold",
					}}
					icon={null}
					content={'Select time to block'}
					closeable
					color='info'
					onClose={() => setIsWaitingBlockTime(false)}
				/>}

				{isWaitingAppointment && <NoticeBar
					className={'block-time-notice'}
					style={{
						position: "fixed",
						bottom: 0, left: 0, width: "100%",
						zIndex: 100,
						height: 60,
						fontSize: 16,
						fontWeight: "bold",
					}}
					icon={null}
					content={'Select time to create appointment'}
					closeable
					color='info'
					onClose={() => setIsWaitingAppointment(false)}
				/>}


				<RefreshAppointments onRefresh={refreshAppointments} />

				{(allowCreateBlockTime || allowCreateAppointment) && <AddNew
					allowCreateBlockTime={allowCreateBlockTime}
					allowCreateAppointment={allowCreateAppointment}
					handleChangeWaitingBlockTime={setIsWaitingBlockTime}
					handleChangeWaitingAppointment={setIsWaitingAppointment}
				/>}

			</PullToRefresh>

		</div>
	)
}

export default Appointments